/* eslint-disable  */
import React from 'react';
import {
  withStyles,
  makeStyles,
  Box,
  FormControlLabel,
  Typography,
  Switch,
} from '@material-ui/core';
import CustomToolTip from 'custom-components/customToolTip';

export const useStyles = makeStyles((theme) => ({
  formControlLabelMargin: {
    marginRight: theme.spacing(0),
    marginLeft: theme.spacing(0),
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        '&.Mui-disabled': {
          opacity: 0.7,
          '&~.MuiSwitch-track ': {
            opacity: 0.7,
          },
        },
      },
    },
  },
}));
const CustomSwitch = withStyles((theme) => ({
  root: {
    width: 47,
    height: 23,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    transform: 'translate(1.5px, 1.5px)',
    '& + $track': {
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        height: '7px',
        width: '7px',
        backgroundColor: 'transparent',
        border: '1px solid #EBE9E7',
        left: 'unset',
        right: '2px',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '50%',
      },
    },
    '&$checked': {
      transform: 'translate(15.5px, 1.5px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: 'var(--vpro-primary-main)',
        opacity: 1,
        border: 'none',
        position: 'relative',
        '&:before': {
          content: '""',
          position: 'absolute',
          height: '7px',
          width: '0.73px',
          backgroundColor: '#fff',
          border: 'none',
          left: '20%',
          right: 'unset',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          borderRadius: 0
        },
      },
    },
    '&$focusVisible $thumb': {
      color: 'var(--vpro-primary-main)',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 28,
    height: 18,
    borderRadius: 73,
  },
  track: {
    borderRadius: 26 / 2,
    border: theme.palette.bg.sidebar,
    backgroundColor: theme.palette.bg.sidebar,
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default function SwitchField(props) {
  const {
    labelPlacement,
    checked,
    onChange,
    name,
    disabled,
    toolTipWithOutIcon = false,
    label = '',
    toolTipWithOutIconText = '',
    tooltipText = '',
    formControlClassName,
  } = props;
  const classes = useStyles();
  return (
    <>
      {toolTipWithOutIcon ? (
        <CustomToolTip title={toolTipWithOutIconText} placement="top">
          <FormControlLabel
            className={`${classes.formControlLabelMargin} ${formControlClassName} `}
            labelPlacement={labelPlacement}
            control={
              <CustomSwitch
                checked={checked}
                onChange={onChange}
                name={name}
                disabled={disabled}
                defaultChecked={checked && disabled}
              />
            }
            label={
              <Typography component="span" variant="body2">
                {label}
                {tooltipText && (
                  <Box
                    display="inline-flex"
                    position="relative"
                    mr={3}
                    style={{ verticalAlign: 'middle' }}>
                    <CustomToolTip isFabIcon title={tooltipText} placement="top" />
                  </Box>
                )}
              </Typography>
            }
          />
        </CustomToolTip>
      ) : (
        <FormControlLabel
          className={`${classes.formControlLabelMargin} ${formControlClassName}`}
          labelPlacement={labelPlacement}
          control={
            <CustomSwitch
              checked={checked}
              onChange={onChange}
              name={name}
              disabled={disabled}
              defaultChecked={checked && disabled}
            />
          }
          label={
            <Typography component="span" variant="body2" style={{ alignItems: 'center ' }}>
              {label}
              {tooltipText && (
                <Box
                  display="inline-flex"
                  position="relative"
                  mr={3}
                  style={{ verticalAlign: 'middle' }}>
                  <CustomToolTip isFabIcon title={tooltipText} placement="top" />
                </Box>
              )}
            </Typography>
          }
        />
      )}
    </>
  );
}
